import defaultTheme from "./clients/defaultTheme";
import ouiTheme from "./clients/ouiTheme";
import blankTheme from "./clients/blankTheme";
import santanderTheme from "./clients/santanderTheme";
import cnnTheme from "./clients/cnnTheme";

const Themes = {
  default: defaultTheme,
  blank: blankTheme,
  "oui-investimentos": ouiTheme,
  santander: santanderTheme,
  cnn: cnnTheme,
};

export default Themes;
